//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/passwordreset"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
    // export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"






// -------------- DLB  --------------




// DASH
export const GET_DASHBOARD = "/dashboard"
export const GET_TASK_LIST = "/tasklist"
export const GET_PPM_DASHBOARD = "/ppmdashboard"
export const GET_PPM_TASK_LIST = "/ppmtasklist"
export const GET_TASK_FILTER = "/ppmdashboard"

export const GET_QR = "/qr"
export const GET_UNPLANNED_FORMS = "/unplannedforms"
export const GET_TASK = "/task"
export const GET_PPM_TASK = "/ppmtask"
export const GET_UNPLANNED_TASK = "/unplannedtask"


export const GET_PPM_CALENDAR = "/ppm/calendar"

// export const GET_ACTIVITIES = "/activities"


// export const GET_NEW_ACTIVITY = "/newactivity"
// export const POST_NEW_ACTIVITY = "/newactivity"


export const GET_NEW_ASSET = "/newasset"
export const GET_ASSETS = "/assets"
export const GET_ASSET = "/asset"
export const DELETE_ASSET = "/asset/delete"
export const POST_NEW_ASSET = "/newasset"


export const GET_PROPERTIES = "/properties"
export const GET_PROPERTY = "/property"
export const DELETE_PROPERTY = "/property/delete"
export const POST_NEW_PROPERTY = "/newproperty"

export const GET_NEW_BLOCK = "/newblock"
export const GET_BLOCKS = "/blocks"
export const GET_BLOCK = "/block"
export const DELETE_BLOCK = "/block/delete"
export const POST_NEW_BLOCK = "/newblock"

export const GET_NEW_BUILDING = "/newbuilding"
export const GET_BUILDINGS = "/buildings"
export const GET_BUILDING = "/building"
export const DELETE_BUILDING = "/building/delete"
export const POST_NEW_BUILDING = "/newbuilding"

export const GET_NEW_FLOOR = "/newfloor"
export const GET_FLOORS = "/floors"
export const GET_FLOOR = "/floor"
export const DELETE_FLOOR = "/floor/delete"
export const POST_NEW_FLOOR = "/newfloor"

export const GET_NEW_ROOM = "/newroom"
export const GET_ROOMS = "/rooms"
export const GET_ROOM = "/room"
export const DELETE_ROOM = "/room/delete"
export const POST_NEW_ROOM = "/newroom"





export const GET_GROUPS = "/groups"
export const GET_GROUP = "/group"
export const DELETE_GROUP = "/group/delete"
export const GET_NEW_GROUP = "/newgroup"
export const POST_NEW_GROUP = "/newgroup"

export const GET_NEW_EMPLOYEE = "/newemployee"
export const GET_EMPLOYEES = "/employees"
export const GET_EMPLOYEE = "/employee"
export const DELETE_EMPLOYEE = "/employee/delete"
export const POST_NEW_EMPLOYEE = "/newemployee"

export const GET_NEW_ADMIN = "/newadmin"
export const GET_ADMINS = "/admins"
export const GET_ADMIN = "/admin"
export const DELETE_ADMIN = "/admin/delete"
export const POST_NEW_ADMIN = "/newadmin"

export const GET_NEW_ACTIVITY = "/newactivity"
export const GET_ACTIVITIES = "/activities"
export const GET_ACTIVITY = "/activity"
export const DELETE_ACTIVITY = "/activity/delete"
export const POST_NEW_ACTIVITY = "/newactivity"

export const GET_ASSETTYPES = "/assettypes"
export const GET_ASSETTYPE = "/assettype"
export const DELETE_ASSETTYPE = "/assettype/delete"
export const POST_NEW_ASSETTYPE = "/newassettype"

export const GET_FORMS = "/forms"
export const GET_FORM = "/form"
export const DELETE_FORM = "/form/delete"
export const POST_NEW_FORM = "/newform"





export const GET_LOADER = "/taskloader"
export const GET_PPM_LOADER = "/ppmtaskloader"
export const GET_PPM_CLEAR = "/ppmtaskclear"

export const GET_FILTERS = "/filters"
export const POST_FILTERS = "/applyfilters"

export const POST_WA_LOGIN = "/walogin"
export const POST_SSO_LOGIN = "/ssologin"



// Reports

// export const GET_DAILYLOGBOOK = "/reports/logbook/daily"
// export const GET_DAILYLOGBOOK = "/daily_logbook_report"
export const GET_DAILYLOGBOOK = "/reports/logbook/daily"
export const INIT_DAILYLOGBOOK = "/reports/logbook/init"
export const GET_DAILYLOGSHEET = "/reports/logsheet/daily"
export const GET_DAILYACTLOGSHEET = "/reports/logsheet/actdaily"
export const GET_DAILYPPMREPORT = "/reports/ppmlogsheet/daily"
export const GET_ACTIVITYPPMREPORT = "/reports/ppmlogsheet/actdaily"

export const INIT_DAILYLOGSHEET = "/reports/logsheet/init"
export const POST_VERIFICATION = "/reports/logsheet/verify"
export const POST_PPM_VERIFICATION = "/reports/logsheet/ppmverify"
export const INIT_ACTDAILYLOGSHEET = "/reports/logsheet/actinit"
export const INIT_ACT_ACTIVITIES = "/reports/logsheet/activities"
export const INIT_ACT_ASSETS = "/reports/logsheet/assets"
export const INIT_PPM_ACT_AVTIVITIES = "/reports/logsheet/ppmactivities"
export const INIT_PPM_ACT_ASSETS = "/reports/logsheet/ppmassets"

export const INIT_PPM = "/reports/logsheet/init_ppm"
export const INITACT_PPM = "/reports/logsheet/init_actppm"

// Reports
export const INIT_ALERTLOG = "/reports/init/alertlog"
export const POST_ALERTLOG = "/reports/alert/log"
export const POST_ALERTSUMMARY = "/reports/alert/summary"
export const POST_ALERTTREND = "/reports/alert/trend"


export const INIT_TASKSNOTDONE = "/reports/init/tasksnotdone"
export const POST_TASKSNOTDONE = "/reports/task/tasksnotdone"
export const POST_ALLSITESTASKSUMMARY = "/reports/task/allsitestasksummary"
export const POST_TASKSUMMARY = "/reports/task/tasksummary"

export const POST_ASSETSTATUSLOG = "/reports/assetstatuslog"
export const POST_REMARKSLOG = "/reports/remarkslog"



//Service Types

export const GET_SERVICE_TYPE = "/service_types"
export const GET_SERVICE_PROFILE = "/service_profiles"
export const SERVICE_PROFILE_FETCHING = "/service_profiles/service_types"
export const SERVICE__FETCHING_FOR_EDIT = "/service_profiles/get"
export const ASSET_TYPE = "/asset_types/list"
export const ASSET_NAME = "/asset_names/get"
export const ACTIVITY_NAME = "/activity_names/get"
export const LOGSHEET_REPORT = "/daily_logsheet_report"
export const GET_LOGSHEET_PPM = "/ppm_logbook_report"
export const GET_ACTIVITY_NAME = "/service_profiles/activities"
export const GET_ASSETS_NAME = "/activities/assets"
export const POST_ACTIVITY_WISE_REPORT = "/assetwise_daily_logsheet_report"
export const VERIFICATION_SUMMARY = "/verification_summary_report"
export const VERIFY_DAILY_LOGSHEET = "/verify_daily_logsheet_report"
export const VERIFICATION_CALENDOR = "/verification_calendar"
export const VERIFICATION_SUMMARY_REPORT_DATEWISE = "/verification_summary_report_datewise"
export const GET_SERVICE_TYPE_PROFILE = "/service_types_profiles"

// export const GET_FORM_PROFILE = "/user"
// export const ADD_NEW_FORM = "/add/user"
// export const UPDATE_FORM = "/update/user"
// export const DELETE_FORM = "/delete/user"


// Alert Reports
export const POST_ALERT_LOG = "/reports/alerts/log"
export const POST_ALERT_SUMMARY = "/reports/alerts/summary"
export const POST_ALERT_TREND = "/reports/alerts/trend"

export const POST_EDIT_CHECKLIST = '/checklist/edit'
export const POST_EDIT_PPM_CHECKLIST = '/ppmchecklist/edit'

// PPM

// export const GET_NEW_VENDOR = "/newvendor"
export const GET_VENDORS = "/vendors"
export const GET_VENDOR = "/vendor"
export const DELETE_VENDOR = "/vendor/delete"
export const POST_NEW_VENDOR = "/newvendor"

export const GET_NEW_CONTRACT = "/newcontract"
export const GET_CONTRACTS = "/contracts"
export const GET_CONTRACT = "/contract"
export const DELETE_CONTRACT = "/contract/delete"
export const POST_NEW_CONTRACT = "/newcontract"

export const GET_NEW_PPMACTIVITY = "/newppmactivity"
export const GET_PPMACTIVITIES = "/ppmactivities"
export const GET_PPMACTIVITY = "/ppmactivity"
export const DELETE_PPMACTIVITY = "/ppmactivity/delete"
export const POST_NEW_PPMACTIVITY = "/newppmactivity"

export const INIT_ONEDASHBOARD = "/onedashboard/init"
export const GET_ONEDASHBOARD = "/onedashboard/analytics"